import axios from 'axios'
import instituteSelector from 'modules/Auth/selectors'
import rolesApi from 'utils/corporateRequest'
import ErrorMessage from 'utils/ErrorMessage'
import request from 'utils/request'
import SuccessMessage from 'utils/SuccessMessage'

export const SET_DRIVE_LIST = 'institute/SET_DRIVE_LIST'
export const SET_PENDING_DRIVE_LIST = 'institute/SET_PENDING_DRIVE_LIST'
export const SET_SELECTED_DRIVE_INFO = 'institute/SET_SELECTED_DRIVE_INFO'

export const setDriveList = data => {
  return {
    type: SET_DRIVE_LIST,
    data,
  }
}
export const setPendingDriveList = data => {
  return {
    type: SET_PENDING_DRIVE_LIST,
    data,
  }
}
export const setSelectedDriveInfo = data => {
  return {
    type: SET_SELECTED_DRIVE_INFO,
    data,
  }
}

export const getDriveListData =
  (query = null, setLoading = true) =>
  async (dispatch, getState) => {
    const state = getState()
    const instituteCampusId = instituteSelector.getInstituteDetails(state).id
    if (setLoading) {
      setLoading(true)
    }
    try {
      let list = await rolesApi.get(
        `/corporates/instituteCampus/${instituteCampusId}/drive/list?${query}`
      )
      dispatch(setDriveList(list.data))
      if (setLoading) {
        setLoading(false)
      }
    } catch (error) {
      if (setLoading) {
        setLoading(false)
      }
    }
  }

export const getPendingDriveListData =
  (setLoading, query = null) =>
  async (dispatch, getState) => {
    const state = getState()
    const instituteCampusId = instituteSelector.getInstituteDetails(state).id
    setLoading(true)
    try {
      let list = await rolesApi.get(
        `/corporates/instituteCampus/${instituteCampusId}/drive/list?${query}`
      )
      dispatch(setPendingDriveList(list.data))
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

export const getSingleDriveInfo =
  (id, setLoading) => async (dispatch, getState) => {
    const state = getState()
    const instituteCampusId = instituteSelector.getInstituteDetails(state).id
    setLoading(true)
    try {
      let res = await rolesApi.get(
        `/corporates/drive/${id}/institute/${instituteCampusId}`
      )
      dispatch(setSelectedDriveInfo(res?.data?.data))
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

export const getFile = async (fileURL, crop, url = '', file = '') => {
  if (url && file) {
    try {
      let fileType = file.type
      let options = {
        headers: {
          'Content-Type': fileType,
        },
      }
      const { status } = await axios.put(url, file, options)
      if (status >= 200 && status < 300) {
        SuccessMessage(
          crop ? 'File cropped successfully!' : 'File Uploaded Successfully!'
        )
        return fileURL
      }
      return false
    } catch (error) {
      ErrorMessage('Failed to upload!')
      return false
    }
  } else {
    ErrorMessage('Failed to upload!')
    return false
  }
}
export const uploadFile = (file, fileName, crop) => async () => {
  try {
    if (file) {
      const data = await request.post(`/signedURL`, {
        files: [
          {
            fileName: fileName,
          },
        ],
      })

      if (data.status >= 200 && data.status < 300) {
        let url = getFile(
          data?.data?.data[0]?.fileURL,
          crop,
          data?.data?.data[0]?.signedURL,
          file
        )
        return url
      }
    }
    return false
  } catch (error) {
    ErrorMessage('Failed to upload!')
    return false
  }
}

export const deleteFile = fileUrl => async () => {
  try {
    if (fileUrl) {
      const data = await request.delete(`/deleteFile`, {
        data: { fileUrl: fileUrl },
      })

      if (data.status >= 200 && data.status < 300) {
        return true
      }
    } else {
      return false
    }
  } catch (error) {
    return false
  }
}

export const getCalandarInfo = () => async () => {
  try {
    let res = await request.get(`/user/thirdPartyIntigrationStatus`)
    return res
  } catch (error) {
    return error
  }
}

export const googleCalendarAuthentication = payload => async () => {
  try {
    let response = await request.post(
      `/user/googleCalendarAuthentication`,
      payload
    )
    if (response?.status >= 200 && response?.status <= 300) {
      SuccessMessage('Calendar integrated successfully!')
    } else if (response?.response?.data?.message) {
      ErrorMessage(response?.response?.data?.message)
    } else {
      ErrorMessage(response?.response?.data?.error)
    }

    return response
  } catch (error) {
    if (error?.response?.data?.message) {
      ErrorMessage(error?.response?.data?.message)
    } else {
      ErrorMessage(error?.response?.data?.error)
    }
    return error
  }
}

export const disconnectGoogleCalender = () => async () => {
  try {
    let res = await request.delete(`/user/removeGoogleCalendarIntigration`)
    return res
  } catch (error) {
    return error
  }
}

export const confirmVirtualDrive =
  ({ driveID, successCallback }) =>
  async (dispatch, getState) => {
    const state = getState()
    const instituteCampusId = instituteSelector.getInstituteDetails(state).id
    try {
      let response = await rolesApi.patch(
        `/corporates/virtualDrive/${driveID}/instituteCampus/${instituteCampusId}/updateDriveStatusToConfirm`
      )
      SuccessMessage('Drive Confirmed Successfully')
      if (successCallback) {
        successCallback()
      }

      return response
    } catch (error) {
      return error?.response
    }
  }

export const requestToChangeVirtualDrive =
  (driveId, payload, successCallBack, errorCallBack) =>
  async (dispatch, getState) => {
    try {
      let response = await rolesApi.patch(
        `/corporates/virtualDrive/${driveId}/requestToChangeDrive`,
        payload
      )
      SuccessMessage('Drive Requested Successfully')
      if (successCallBack) {
        successCallBack()
      }
      return response
    } catch (error) {
      return error?.response
    }
  }
